import type { Lot } from "@/features/lots/types";

type Args = {
  lotId: string | null | undefined;
  lot: Lot | undefined;
  isLoading?: boolean;
  isError?: boolean;
};

// Etiqueta del lote para listas/detalle de costos.
//
// Prioridad: loading/error sobre data, porque sin lots cargados no
// podemos saber si el id existe o no — antes esto rendía "Lote eliminado"
// en cualquier flap de red.
export function resolveLotLabel({ lotId, lot, isLoading, isError }: Args): string {
  if (!lotId) return "—";
  if (isLoading) return "—";
  if (isError) return "—";
  if (lot) return lot.name;
  return "Lote desconocido";
}
